import React from 'react';

const JS_2018 = () => {
  return (
    <div >
      <h1>JS_2018</h1>
      <p>Placeholder component for: "JS 2018"</p>
    </div>
  );
};

export default JS_2018;
